














import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class Rating extends Vue {
    @Prop() movieRating!: number;

    @Prop() scores!: number;

    get movieRatingValue() {
        return this.movieRating;
    }

    // Fake setter to avoid errors in console
    set movieRatingValue(value) {
        const x = value;
    }

    get color() {
        let result = 'red';

        if (this.movieRating >= 70) {
            result = 'green';
        } else if (this.movieRating >= 40) {
            result = 'yellow';
        } else if (this.scores === 0) {
            result = '';
        }

        return result;
    }
}
